<template>
    <div class="d-inline-flex align-center " >
        <v-icon v-if="!compraSuspensa" size="16" color="error">far fa-clock</v-icon>
        <v-icon v-else size="16" color="warning">fas fa-pause</v-icon>
        <span class="ml-1">{{ compraSuspensa ? 'Compra Direta suspensa' : tempoRestante }}</span>
    </div>
</template>

<script>
import moment from 'moment'

export default {
    name: 'CountDownDesempate',
    props: ['dataHoraAtual', 'dataHoraFimDesempate', 'situacaoCompra'],
    data() {
        return {
            tempoRestante: null,
            intervalo: null,
        }
    },
    computed: {
        compraSuspensa() {
            return this.situacaoCompra === 'SUSPENSA'
        }
    },
    mounted() {
        if (!this.compraSuspensa) {
            this.iniciarCronometro()
        }
    },
    watch: {
        compraSuspensa(novoValor) {
            if (novoValor) {
                this.pararCronometro()
            } else {
                this.iniciarCronometro()
            }
        }
    },
    methods: {
        iniciarCronometro() {
            if (this.intervalo) {
                clearInterval(this.intervalo)
            }
            
            const countDown = this.getTempoRestante()
            this.getTempoRestanteFormatado(countDown)

            this.intervalo = setInterval(() => {
                this.getTempoRestanteFormatado(countDown)
            }, 1000)
        },
        pararCronometro() {
            if (this.intervalo) {
                clearInterval(this.intervalo)
                this.intervalo = null
            }
        },
        getTempoRestante() {
            const dataAtual = moment(this.dataHoraAtual)
            const dataFimDesempate = moment(this.dataHoraFimDesempate)
            return moment.duration(dataFimDesempate.diff(dataAtual))
        },
        getTempoRestanteFormatado(countDown) {
            const novoTempo = countDown.subtract(1, 'seconds')

            if (novoTempo.asSeconds() <= 0 && novoTempo.asMinutes() <= 0) {
                clearInterval(this.intervalo)
                this.tempoRestante = '00:00'
                this.$emit('tempoDesempateEncerrado')
            }else{
                this.tempoRestante = `${novoTempo.minutes().toString().padStart(2, '0')}:${novoTempo.seconds().toString().padStart(2, '0')}`
            }
        }
    },
    destroyed() {
        clearInterval(this.intervalo)
        this.intervalo = null
    }
}
</script>

<style scoped lang="stylus">

</style>